module.exports = __webpack_public_path__ + "2.469e003e44a67c7ef137.png";


//////////////////
// WEBPACK FOOTER
// C:/Users/anderson.oshiro/Projetos/Azure/Ipcorp.PortalCobranca/Web/Ipcorp.PortalCobranca.Web/src/assets/images/background/2.png
// module id = ../../../../../src/assets/images/background/2.png
// module chunks = main styles